import { useEffect } from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Outlet, useNavigate } from "react-router-dom";
import { FormAction, FormProps } from "../../../interfaces/form-action-interfaces";
import { Card, CardHeader, CardBody, CardFooter } from "../../forms/components/card";
import { PageTitle } from "../../forms/components/page-title";
import { Table } from "../../forms/components/table";
import { CategoryData } from "../interfaces/category-result.interface";
import { GetAllCategoryParam } from "../providers/category.provider";
import { useCategoryStore } from "../states/category.state";

export const CategoryLayout = () => {
  return (
    <>
      <PageTitle
        title={'Category'}
        subtitle={'This is an example dashboard created using build-in elements and components.'}
      />
      <Outlet/>
    </>
  );
}

export const CategoryScreen = () => {

  const { categories, getCategories, categoryModel, onDeleteCategory } = useCategoryStore();
  const [categoryParams, setCategoryParams] = useState<GetAllCategoryParam>({ page: 0, limit: 10 });
  const navigate = useNavigate();

  useEffect(() => {
    getCategories(categoryParams);
  }, [])

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected + 1;
    setCategoryParams({ 
      ...categoryParams,
      page: selectedPage
    })
  }

  const handleOnEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: CategoryData) => {
    e.preventDefault();
    navigate('form', {
      state: {
        action: FormAction.UPDATE,
        title: 'Category',
        subtitle: 'Form Category',
        id: item.id,
      } as FormProps
    });
  }

  const handleOnView = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: CategoryData) => {
    e.preventDefault();
    navigate('form', {
      state: {
        action: FormAction.VIEW,
        title: 'Category',
        subtitle: 'Form Category',
        id: item.id
      } as FormProps
    });
  }

  return (
    <>
      <Card>
        <CardHeader title={'Category'}>
          <div className="btn-actions-pane-right">
            <button 
              className="btn btn-outline-success"
              onClick={(e) => {
                e.preventDefault();
                navigate('form', {
                  state: {
                    action: FormAction.CREATE,
                    title: 'Category',
                    subtitle: 'Form Category'
                  } as FormProps
                });
              }}>
              <i className="fa fa-plus"></i>
            </button>
          </div>
        </CardHeader>
        <CardBody clean={true}>
          <Table
            data={categories}
            actionButton={(index, item) => {
              let data: CategoryData = item as CategoryData;
              return (
                <div role={'group'} className="btn-group-sm btn-group btn-group-toggle">
                  {
                    <>
                      <button type="button" className="btn btn-primary" onClick={(e) => handleOnView(e, data)}>View</button>
                      <button type="button" className="btn btn-danger" onClick={e => onDeleteCategory(data.id, categoryParams)}>Delete</button>
                      <button type="button" className="btn btn-warning" onClick={e => handleOnEdit(e, data)}>Edit</button>
                    </>
                  }
                </div>
              );
            }}
          />
        </CardBody>
        <CardFooter>
          <ReactPaginate
            previousLabel={"«"}
            nextLabel={"»"}
            breakLabel={"..."}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            pageCount={categoryModel?.data?.meta?.totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination pagination-sm m-0 float-right"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </CardFooter>
      </Card>
    </>
  );
}